<template>
    <header>
        <div id="Header" class="clearfix">
            <div class="container">
                <div class="drawer">
                    <a class="menu-trigger" @click="openHumburger()">
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>
                </div>
                <h1>GR</h1>
            </div>
            <h2 v-if="siteInfo !== null">{{ siteInfo[0].cont_name }}</h2>
            <div class="logout">
                <span class="logout-icon" @click="showHeaderMenu">▼</span>
            </div>
        </div>
        <div v-show="is_showHeaderMenu" id="header-menu-box">
            <a :href="'/help?site_no=' + this.$store.getters['auth/getSiteNo']" target="_blank" class="header-menu" id="help-button">ヘルプ</a>
            <div class="header-menu" id="logout-button" @click="logout()">ログアウト</div>
        </div>
    </header>
</template>

<script>
import $ from "jquery"; // eslint-disable-line
const logoutUrl = process.env.VUE_APP_LOGOUT;

export default {
    name: "Header",
    data() {
        return {
            is_showHeaderMenu: false,
        };
    },
    props: {
        siteInfo: {
            type: Array
        }
    },
    methods: {
        showHeaderMenu() {
            this.is_showHeaderMenu = !this.is_showHeaderMenu;
        },
        logout() {
            sessionStorage.clear();
            window.localStorage.removeItem("TodoApp");
            window.location.href = logoutUrl;
        },
        openHumburger() {
            $("#Navigation div.container").toggle(300);
            $("#mainBlock").toggleClass("blur");
            $("#blackPanel").toggleClass("active");
            $(".menu-trigger").toggleClass("active");

            // オーバーレイの高さ調整
            if ($("html").outerHeight() > window.innerHeight) {
                // スクロールありの場合、htmlの高さを適用
                $(`#blackPanel`).css("height", `${$("html").outerHeight()}px`);
            } else {
                // スクロールなしの場合、windowの高さを適用
                $(`#blackPanel`).css("height", `${window.innerHeight}px`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url(../../assets/css/header/Header.css);
</style>
